'use client';

import { c as _c } from "react/compiler-runtime";
import type { UserGiftStatParams } from '@module/apis/client-side/heart/type';
import { cn } from '@module/lib/utils';
import { useFetchUserGiftChartDataQuery } from '@module/queries/heart/heartQueryHooks';
import { useState } from 'react';
import { CartesianGrid, Legend, Line, LineChart, Surface, Symbols, Tooltip, XAxis, YAxis } from 'recharts';
function TooltipContent(t0) {
  const $ = _c(7);
  const {
    active,
    payload
  } = t0;
  if (active && payload && payload.length) {
    let t1;
    if ($[0] !== payload[0].payload.date) {
      t1 = <p>{payload[0].payload.date}</p>;
      $[0] = payload[0].payload.date;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== payload[0].value) {
      t2 = <p className="text-[#fff]">선물받은 하트 : {payload[0].value}</p>;
      $[2] = payload[0].value;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = <div className="bg-primaryBg p-3 text-[#777]">{t1}{t2}</div>;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
}
function GiftChartContainer() {
  const $ = _c(33);
  const [chartType, setChartType] = useState("day");
  let t0;
  if ($[0] !== chartType) {
    t0 = {
      type: chartType
    };
    $[0] = chartType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: chartData
  } = useFetchUserGiftChartDataQuery(t0);
  let t1;
  if ($[2] !== chartData) {
    t1 = chartData ? Object.keys(chartData.chart).map(key => ({
      date: key,
      value: chartData.chart[key]
    })) : [];
    $[2] = chartData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const parsedChartData = t1;
  const tooltipContentProp = _temp;
  const t2 = chartType === "day";
  let t3;
  if ($[4] !== t2) {
    t3 = cn({
      "font-semibold": t2
    });
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setChartType("day");
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <button className={t3} type="button" onClick={t4}>일간</button>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="mx-2 inline-block h-4 w-[1px] bg-borderBg07" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = chartType === "week";
  let t8;
  if ($[10] !== t7) {
    t8 = cn("", {
      "font-semibold": t7
    });
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setChartType("week");
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8) {
    t10 = <button className={t8} type="button" onClick={t9}>주간</button>;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="mx-2 inline-block h-4 w-[1px] bg-borderBg07" />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = chartType === "month";
  let t13;
  if ($[16] !== t12) {
    t13 = cn({
      "font-semibold": t12
    });
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setChartType("month");
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t13) {
    t15 = <button className={t13} type="button" onClick={t14}>월간</button>;
    $[19] = t13;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t10 || $[22] !== t15 || $[23] !== t5) {
    t16 = <div className="mb-7 flex w-full items-center justify-end text-baseFg">{t5}{t6}{t10}{t11}{t15}</div>;
    $[21] = t10;
    $[22] = t15;
    $[23] = t5;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== chartData || $[26] !== parsedChartData) {
    t17 = chartData && <LineChart width={1280} height={300} data={parsedChartData} margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }}><CartesianGrid stroke="#77777733" /><XAxis dataKey="date" tick={{
        fontSize: 12
      }} /><YAxis tick={{
        fontSize: 12
      }} tickCount={8} /><Tooltip content={tooltipContentProp} /><Legend verticalAlign="top" height={36} content={_temp3} /><Line type="linear" dataKey="value" stroke="currentColor" strokeWidth={2} activeDot={{
        r: 8
      }} /></LineChart>;
    $[25] = chartData;
    $[26] = parsedChartData;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t17) {
    t18 = <div className="mt-4 h-[300px] text-colorChart01">{t17}</div>;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t16 || $[31] !== t18) {
    t19 = <div className="mb-20 flex flex-col items-center">{t16}{t18}</div>;
    $[30] = t16;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  return t19;
}
function _temp3(t0) {
  const {
    payload: payload_0
  } = t0;
  return payload_0?.map(_temp2);
}
function _temp2(_, idx) {
  return <div key={idx} className="flex items-baseline justify-center gap-2"><Surface width={10} height={10}><Symbols cx={5} cy={5} type="square" size={100} fill="currentColor" /></Surface><span className="text-[#777] text-xs">선물 받은 하트</span></div>;
}
function _temp(t0) {
  const {
    active,
    payload
  } = t0;
  return <TooltipContent active={active} payload={payload} />;
}
export default GiftChartContainer;